module.exports = __webpack_public_path__ + "static/media/cafe.229b595e.png";